import * as React from "react";
import Button from "@mui/material/Button";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {StyledMenu} from "./StyledMenu";
import {MenuItem} from "@mui/material";
import {useTranslate} from "@tolgee/react";

export function AddMappedModuleButton(props: {
    options: { translatedTitle: string, key: string, otherKeys: string[] }[],
    onAdd: (key: string, otherKeys: string[]) => void
}) {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const {t} = useTranslate();

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return <div>
        <Button
            id="demo-customized-button"
            aria-controls={open ? "add modules" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            color="inherit"
            disableElevation
            onClick={handleClick}
            endIcon={<KeyboardArrowDownIcon/>}
        >
            {t("mappings_add")}
        </Button>
        <StyledMenu
            id="demo-customized-menu"
            MenuListProps={{
                "aria-labelledby": "demo-customized-button",
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
        >
            {
                props.options.map(option => (
                    <MenuItem
                        onClick={() => {
                            handleClose();
                            props.onAdd(option.key, option.otherKeys)
                        }}
                        disableRipple
                        key={option.key}
                    >
                        {option.translatedTitle}
                    </MenuItem>
                ))
            }
        </StyledMenu>
    </div>;
}